import React from "react";
import { Link, useLocation } from "react-router-dom";
import MainLayOut from "../layout/MainLayOut";
import { BiChevronLeft } from "react-icons/bi";

const answers = {
  // Orders, Delivery & Payment
  "/contact-us/order-delivery-payment/how-do-i-know-if-my-order-was-successfully-placed":
    "Once your order is placed, you will be directed to the order confirmation page where you can check your purchase details. Additionally, you will receive an email with your order confirmation and tracking information. You can also track your order in 'My Orders' on our website. Thank you for choosing MPI Virgin Plastic! 🌱",

  "/contact-us/order-delivery-payment/what-are-the-charges-that-will-apply-on-my-order":
    "For all orders below Rs 199, a small delivery charge will apply. Additionally, if you choose Cash on Delivery (COD), there will be a COD charge of Rs 20. Please note that all prices include taxes. Happy shopping for your planters, containers, and more!",

  "/contact-us/order-delivery-payment/why-cant-i-see-the-cod-option":
    "Unfortunately, COD is unavailable for certain pin codes and in specific cases. If you've used a coupon code or selected specific products that are only available for prepaid orders, you’ll need to use a debit/credit card or online wallet to pay. If you’ve had multiple failed COD attempts, the option may not appear for new orders. Feel free to contact us for more details.",

  "/contact-us/order-delivery-payment/i-am-unable-to-add-products-to-my-bag":
    "Please ensure that the products you wish to purchase are in stock. Try refreshing the website or clearing your cache and cookies. If the problem persists, reach out to our customer support with a screenshot of the issue, and we'll assist you as soon as possible. 🛒",

  "/contact-us/order-delivery-payment/my-order-is-shipped-but-not-yet-delivered":
    "We're sorry for the inconvenience. If your order has shipped but you haven’t received it, please email us with your order ID. Our customer service team will get in touch with you within 24 hours to resolve the issue.",

  "/contact-us/order-delivery-payment/i-have-not-received-an-order-confirmation":
    "Don’t worry! If your order is listed in the 'My Orders' section, your confirmation email is on the way. Be sure to check your spam folder, just in case. Thank you for choosing MPI Virgin Plastic for your home and garden needs!",

  "/contact-us/order-delivery-payment/i-want-to-change-the-phone-number-for-the-order":
    "If you need to update your contact details, simply email us at support@mpivirginplastic.com with your order number and the new phone number. We’ll take care of the rest.",

  "/contact-us/order-delivery-payment/i-wasnt-available-at-the-time-of-delivery-but-i-want-my-order-what-do-i-do":
    "No problem! Our delivery partner will attempt to deliver your order two more times. If you're unavailable, please feel free to reach out to schedule a convenient delivery time.",

  "/contact-us/order-delivery-payment/i-tried-to-make-a-transaction-but-it-failed-what-do-i-do":
    "If the payment failed but the money was deducted from your bank or card, don’t worry! It will be refunded within 3-5 business days. In the meantime, you can try placing the order again using a different payment method like debit card, credit card, or online wallets.",

  "/contact-us/order-delivery-payment/i-have-self-shipped-how-do-i-get-the-refund":
    "If you’ve shipped the product back on your own, please email us the courier receipt along with your order ID. Our team will review it and process the refund within 24 hours.",

  "/contact-us/order-delivery-payment/will-mpi-virgin-plastic-employee-ask-for-my-confidential-information":
    "For your security, we will never ask for sensitive information such as passwords, OTPs, or card details. If you receive such requests, please report them to us immediately. Your privacy is our top priority!",

  "/contact-us/order-delivery-payment/how-can-i-get-a-refund-of-the-cod-charges":
    "COD charges are generally non-refundable. However, if there's a special case, we may process a refund to your MPI Virgin Plastic wallet. Please contact us for further details.",

  // Cancellations
  "/contact-us/cancellations/can-i-cancel-my-order":
    "Yes! You can cancel your order within 24 hours of confirmation. If you need to cancel after that, please reach out to our customer support team, and we will assist you.",

  "/contact-us/cancellations/how-do-i-cancel-my-order-which-is-already-in-progress":
    "If your order is already in progress, please contact us immediately at support@mpivirginplastic.com with your order number. We will check if cancellation is possible.",

  "/contact-us/cancellations/can-i-cancel-my-cancellation-request":
    "Once an order cancellation request is processed, it cannot be reversed. If you change your mind, you will need to place a new order.",

  // Refunds & Returns
  "/contact-us/refunds-returns/how-do-i-return-my-product":
    "You can return products within 15 days from delivery, as long as they are in new, unused condition. Simply log into your account and click 'Return' under 'My Orders'. We’re here to help you make your shopping experience hassle-free!",

  "/contact-us/refunds-returns/how-will-i-get-my-refund":
    `Refunds are processed once we receive and inspect the returned item. Depending on the method you choose, the refund will be issued within the following timelines:
    - Wallet Refund: Immediately
    - NEFT: 3-5 business days
    - Payment Gateway: 5-7 business days.`,

  "/contact-us/refunds-returns/i-wish-to-exchange-my-product":
    `Exchanges are available within 15 days for size-related issues or MPI Virgin Plastic-owned products. You can request an exchange, and we will send a new product once the original is picked up.`,

  "/contact-us/refunds-returns/self-ship-policy":
    `If your pin code is not covered by our pick-up service, you can self-ship the return through a trusted courier partner. We will reimburse your shipping costs once we receive the shipping receipt.`,

  "/contact-us/refunds-returns/my-product-has-not-yet-been-picked-up":
    `If your product has not been picked up yet, please reach out to our customer support team, and we will get back to you within 24 hours.`,

  "/contact-us/refunds-returns/my-product-has-been-picked-up-but-i-have-not-been-refunded-yet":
    `Once your returned item is picked up, we will process your refund within 48 hours. Depending on the payment method, you should receive your refund within the following timelines:
    - Wallet Refund: Immediately
    - NEFT: 3-5 business days
    - Payment Gateway: 5-7 business days.`,

  // My MPI Virgin Plastic order
  "/contact-us/order/my-order-is-not-yet-packed-shipped":
    `We take great care in packing each order to ensure the safety and quality of your items. Orders typically ship within 4-5 working days. Thank you for your patience as we process your order with care!`,

  "/contact-us/order/how-do-i-check-the-status-of-my-order":
    `To check the status of your order, log into your account and click on 'Track Order'. You'll receive an email with tracking details, and it may take up to 24 hours for the tracking link to be active.`,

  "/contact-us/order/how-can-i-cancel-my-order":
    `Orders can be canceled within 24 hours of placement. After that, cancellations might not be possible. For any difficulties, contact us immediately for assistance.`,

  // My Account
  "/contact-us/account/how-do-i-change-my-password":
    `Go to 'Account Settings' and select 'Change Password'. Enter your current password and the new one to update.`,

  "/contact-us/account/update-my-address":
    `To update your address, go to 'My Account' > 'Manage Addresses' and make your changes.`,

  // Offers and Combos
  "/contact-us/offers-combos/how-to-apply-offers":
    `At checkout, you can enter your coupon code in the 'Apply Coupon' section to enjoy any available discounts or offers.`,

  "/contact-us/offers-combos/combo-terms-&-conditions":
    `Combo offers apply to selected products only and cannot be combined with other discounts unless specified.`,

  // Membership
  "/contact-us/membership/what-is-mpi-virgin-plastic-membership":
    `MPI Virgin Plastic Membership gives you access to exclusive offers, early-bird sales, and free shipping on all orders.`,

  "/contact-us/membership/benefits-of-membership":
    `Enjoy perks like flat discounts, priority access to new products, and free shipping on every order!`
};

const AnswerPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const pageIdRaw = decodeURIComponent(params.get("pageId") || "");
  const pageId = pageIdRaw.replace(/\?$/, ""); // Clean up

  const answer = answers[pageId] || "Answer not found. Please check your question.";

  return (
    <MainLayOut>
      <div className="max-w-2xl mx-auto p-6 space-y-4 h-lvh">
        <Link className="text-blue-700 font-medium flex items-center gap-1 text-xs" to={'/contact-us'}> <BiChevronLeft /> Back</Link>
        <h2 className="text-2xl font-bold">Answer</h2>
        <p className="text-gray-700">{answer}</p>
      </div>
    </MainLayOut>
  );
};

export default AnswerPage;
